type CoordData = {
    title:string,
    x:number,
    y:number,
    max:boolean,
}


function parse(xmlString:string):Record<string, CoordData>{
    const parser = new DOMParser();
    const xml = parser.parseFromString(xmlString, 'text/xml');    
    
    var result:Record<string, CoordData> = {};
    var items = xml.getElementsByTagName("item");
    for(var i=0; i < items.length; i++){
        var item = items[i]
        var title = item.getAttribute('title')!
        result[title] = {
            title,
            x: parseFloat(item.getAttribute('xPos')!),
            y: parseFloat(item.getAttribute('yPos')!),
            max: false,
        }
    }

    return result;
}


function luxParse(xmlString:string, frame:number):Record<string, CoordData>{
    const parser = new DOMParser();
    const xml = parser.parseFromString(xmlString, 'text/xml');    
    var result:Record<string, CoordData> = {};
    var items = xml.getElementsByTagName("item");

    var on:boolean = false;

    for(var i=0; i < items.length; i++){
        var item = items[i]
        var title = item.getAttribute('title')!;

        if(title.indexOf("_00018")!=-1) on = frame==18;
        else if(title.indexOf("00000")!=-1) on = frame==0;
        else if(on){
            result[title] = {
                title,
                x: parseFloat(item.getAttribute('xPos')!),
                y: parseFloat(item.getAttribute('yPos')!) + 100,
                max: true,
            }
        }
    }

    return result;
}


const coordData = {
    0: {
        ...parse(require('!!raw-loader!./coords/00/level1_00.xml').default),
        ...parse(require('!!raw-loader!./coords/00/level2_00.xml').default),
        ...parse(require('!!raw-loader!./coords/00/level3_00.xml').default),
        ...parse(require('!!raw-loader!./coords/00/level4_00.xml').default),
        ...parse(require('!!raw-loader!./coords/00/level5_00.xml').default),
        ...parse(require('!!raw-loader!./coords/00/level6_00.xml').default),
        ...parse(require('!!raw-loader!./coords/00/level7_00.xml').default),
        ...parse(require('!!raw-loader!./coords/00/level8_00.xml').default),
        ...parse(require('!!raw-loader!./coords/00/level9_00.xml').default),
        ...parse(require('!!raw-loader!./coords/00/level10_00.xml').default),
        ...parse(require('!!raw-loader!./coords/00/level11_00.xml').default),
        ...parse(require('!!raw-loader!./coords/00/level12_00.xml').default),
        ...parse(require('!!raw-loader!./coords/00/level13_00.xml').default),
        ...luxParse(require('!!raw-loader!./coords/lux/bkg--masterplan.xml').default, 0),
    },
    18: {
        ...parse(require('!!raw-loader!./coords/18/level1_18.xml').default),
        ...parse(require('!!raw-loader!./coords/18/level2_18.xml').default),
        ...parse(require('!!raw-loader!./coords/18/level3_18.xml').default),
        ...parse(require('!!raw-loader!./coords/18/level4_18.xml').default),
        ...parse(require('!!raw-loader!./coords/18/level5_18.xml').default),
        ...parse(require('!!raw-loader!./coords/18/level6_18.xml').default),
        ...parse(require('!!raw-loader!./coords/18/level7_18.xml').default),
        ...parse(require('!!raw-loader!./coords/18/level8_18.xml').default),
        ...parse(require('!!raw-loader!./coords/18/level9_18.xml').default),
        ...parse(require('!!raw-loader!./coords/18/level10_18.xml').default),
        ...parse(require('!!raw-loader!./coords/18/level11_18.xml').default),
        ...parse(require('!!raw-loader!./coords/18/level12_18.xml').default),
        ...parse(require('!!raw-loader!./coords/18/level13_18.xml').default),
        ...luxParse(require('!!raw-loader!./coords/lux/bkg--masterplan.xml').default, 18),
    }
} as Record<number, Record<string, CoordData>>

export default coordData;